import React from 'react';
import ReactDOM from 'react-dom';
import { MagstimModal, CurrentLang } from "common";
import './index.css';
import App from './App';

import * as serviceWorker from './serviceWorker';

import { HashRouter  } from 'react-router-dom';

const _modal = React.createRef();

ReactDOM.render(       
        <HashRouter  
                getUserConfirmation={(message, callback) => {
            
                    const modalCallBack = (result) => {
                        try{
                            // Check the result
                            if(result === _modal.current.getPositiveButtonText()) {
                                callback(true)
                            }else{
                                callback(false)
                            }
                        }
                        catch(error){
                            // Log
                            console.log(error);

                            // Any issues just close
                            callback(true)
                        }
                    }    
                
                try{
                    _modal.current.show(CurrentLang().cancel_warning_title, message, CurrentLang().message_box_ok, CurrentLang().message_box_cancel, modalCallBack)
                }
                catch(error){
                    // Log
                    console.log(error);

                    // this is the default behavior
                    const allowTransition = window.confirm(message);
                    callback(allowTransition);
                }    
                    
            }}> 
            <MagstimModal ref={_modal}></MagstimModal>
            <App /> 
        </HashRouter >, document.getElementById('root'));

                        
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (process.env.NODE_ENV === "production") console.log = () => {};
